import React from 'react';
import { Link } from 'react-router-dom';

const BillboardSection = ({ userVerified }) => {
  return (
    <section className="billboard-section">
      <div className="billboard-container">
        <div className="billboard-content">          <div className="billboard-text-column">            <h2 className="billboard-title">
              <span className="billboard-title-line1">Create your poster.</span>
              <br />
              <span className="billboard-title-line2">Get a chance to be featured on our billboard*</span>
            </h2>
            {userVerified ? (
              <Link to="/add-details" className="btn-neo poster-btn billboard-btn">
                <strong>Continue My Poster</strong> <span>&gt;</span>
              </Link>
            ) : (
              <Link to="/otp-verification" className="btn-neo poster-btn billboard-btn">
                <strong>Make My Poster</strong> <span>&gt;</span>
              </Link>
            )}
            <div className="billboard-tnc">
              <Link to="/terms-and-conditions" className="billboard-tnc-link">
                *T&C Apply
              </Link>
            </div>
          </div>
            <div className="billboard-image-column">
            <img 
              src="/outdoorbillboard.png" 
              alt="Outdoor Billboard" 
              className="billboard-image"
              loading="lazy"
            />
            <div className="billboard-tnc-mobile">
              <Link to="/terms-and-conditions" className="billboard-tnc-link">
                *T&C Apply
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BillboardSection;